export const UPLOAD_SELFIE_VALUE = '__upload_selfie__';
export const TALK_TO_PRO_VALUE = '__talk_to_pro__';
export const SHADE_OFFER_YES_VALUE = '__shade_offer_yes__';
export const SHADE_OFFER_NO_VALUE = '__shade_offer_no__';
export const SHADE_VIRTUAL_MIRROR_VALUE = '__shade_virtual_mirror__';
export const SHADE_MIRROR_YES_VALUE = '__shade_mirror_yes__';
export const SHADE_MIRROR_NO_VALUE = '__shade_mirror_no__';
export const SHADE_MIRROR_ADD_YES_VALUE = '__shade_mirror_add_yes__';
export const SHADE_MIRROR_ADD_NO_VALUE = '__shade_mirror_add_no__';
export const ORDER_STATUS_VALUE = '__order_status__';
export const ORDER_REPORT_ISSUE_VALUE = '__order_report_issue__';
export const ORDER_REORDER_VALUE = '__order_reorder__';
export const ORDER_SUBSCRIBE_VALUE = '__order_subscribe__';
export const RETURN_EXCHANGE_TRIGGER = '__return_exchange__';
export const FIND_MY_SHADE_VALUE = '__find_my_shade__';
export const PRODUCT_QUESTION_VALUE = '__product_question__';
export const ORDER_ISSUE_VALUES = new Set([
  '__order_issue_damaged__',
  '__order_issue_defective__',
  '__order_issue_wrong_items__',
  '__order_issue_missing_items__',
  '__order_issue_refund__',
  '__order_issue_edit__',
  '__order_issue_other__',
]);
export const RETURN_EXCHANGE_REASON_WRONG_SHADE_VALUE = '__return_exchange_wrong_shade__';
export const RETURN_EXCHANGE_REASON_TOO_CAKEY_VALUE = '__return_exchange_too_cakey__';
export const RETURN_EXCHANGE_REASON_TOO_EXPENSIVE_VALUE = '__return_exchange_too_expensive__';
export const RETURN_EXCHANGE_REASON_WRONG_DAMAGED_VALUE = '__return_exchange_wrong_damaged__';
export const RETURN_EXCHANGE_REASON_LABELS: Record<string, string> = {
  [RETURN_EXCHANGE_REASON_WRONG_SHADE_VALUE]: 'Wrong Shade',
  [RETURN_EXCHANGE_REASON_TOO_CAKEY_VALUE]: 'Too Cakey',
  [RETURN_EXCHANGE_REASON_TOO_EXPENSIVE_VALUE]: 'Too Expensive',
  [RETURN_EXCHANGE_REASON_WRONG_DAMAGED_VALUE]: 'Received Wrong / Damaged Item',
};
export const RETURN_EXCHANGE_REASON_VALUES = new Set([
  RETURN_EXCHANGE_REASON_WRONG_SHADE_VALUE,
  RETURN_EXCHANGE_REASON_TOO_CAKEY_VALUE,
  RETURN_EXCHANGE_REASON_TOO_EXPENSIVE_VALUE,
  RETURN_EXCHANGE_REASON_WRONG_DAMAGED_VALUE,
]);
export const LIVE_AGENT_HANDOFF_VALUE = '__live_agent_handoff__';
export const KLAVIYO_FORM_ID = 'klaviyo_subscribe';
export const TALK_TO_PRO_LABELS = new Set(['talk to a pro', 'talk to pro', 'talk with a pro']);
export const PRODUCT_QUESTION_LABELS = new Set(['product question', 'product questions', 'product support']);
export const LIVE_AGENT_LABELS = new Set([
  'talk to a live agent',
  'talk to live agent',
  'talk to a human',
  'talk to human',
]);
